import React from "react";
import { Field, reduxForm } from "redux-form";
import { FormField } from "./../Common/Form/FormField";
import i18n from "i18next";

const UserPreferencesProfile = () => {
  return (
    <form className="profile">
      <Field component={FormField} className="input__fieldset" name="userName" label={i18n.t("userPreferences.name")} disabled />
      <Field component={FormField} className="input__fieldset" name="email" label={i18n.t("userPreferences.email")} disabled />
    </form>
  );
};

export default reduxForm({ form: "userProfile", enableReinitialize: true })(UserPreferencesProfile);



// WEBPACK FOOTER //
// ./src/components/UserPreferences/UserPreferencesProfile.js